import React from 'react'
import SbEditable from 'storyblok-react'

const EmbeddedContent = (props) => {
    return (
        <SbEditable content={props.blok}>
            <section>
                <div dangerouslySetInnerHTML={{ __html: props.blok.code }}></div>
            </section>
        </SbEditable>
    )
}

export default EmbeddedContent